<!-- Item wrapper -->
<div
  [class.fuse-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
  [ngClass]="item.classes?.wrapper"
  class="fuse-horizontal-navigation-item-wrapper">
  <!-- Item with an internal link -->
  <ng-container
    *ngIf="item.link && !item.externalLink && !item.function && !item.disabled">
    <div
      [ngClass]="{
        'fuse-horizontal-navigation-item-active-forced': item.active
      }"
      class="fuse-horizontal-navigation-item"
      [fragment]="item.fragment ?? undefined"
      [matTooltip]="item.tooltip || ''"
      [preserveFragment]="item.preserveFragment ?? false"
      [queryParams]="item.queryParams ?? null"
      [queryParamsHandling]="item.queryParamsHandling ?? null"
      [routerLink]="[item.link]"
      [routerLinkActive]="'fuse-horizontal-navigation-item-active'"
      [routerLinkActiveOptions]="isActiveMatchOptions">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
  </ng-container>

  <!-- Item with an external link -->
  <ng-container
    *ngIf="item.link && item.externalLink && !item.function && !item.disabled">
    <a
      class="fuse-horizontal-navigation-item"
      [href]="item.link"
      [matTooltip]="item.tooltip || ''"
      [target]="item.target || '_self'">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
  </ng-container>

  <!-- Item with a function -->
  <ng-container *ngIf="!item.link && item.function && !item.disabled">
    <div
      [ngClass]="{
        'fuse-horizontal-navigation-item-active-forced': item.active
      }"
      class="fuse-horizontal-navigation-item"
      [matTooltip]="item.tooltip || ''"
      (click)="item.function(item)">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
  </ng-container>

  <!-- Item with an internal link and function -->
  <ng-container
    *ngIf="item.link && !item.externalLink && item.function && !item.disabled">
    <div
      [ngClass]="{
        'fuse-horizontal-navigation-item-active-forced': item.active
      }"
      class="fuse-horizontal-navigation-item"
      [fragment]="item.fragment ?? undefined"
      [matTooltip]="item.tooltip || ''"
      [preserveFragment]="item.preserveFragment ?? false"
      [queryParams]="item.queryParams ?? null"
      [queryParamsHandling]="item.queryParamsHandling ?? null"
      [routerLink]="[item.link]"
      [routerLinkActive]="'fuse-horizontal-navigation-item-active'"
      [routerLinkActiveOptions]="isActiveMatchOptions"
      (click)="item.function(item)">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
  </ng-container>

  <!-- Item with an external link and function -->
  <ng-container
    *ngIf="item.link && item.externalLink && item.function && !item.disabled">
    <a
      mat-menu-item
      class="fuse-horizontal-navigation-item"
      [href]="item.link"
      [matTooltip]="item.tooltip || ''"
      [target]="item.target || '_self'"
      (click)="item.function(item)">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
  </ng-container>

  <!-- Item with a no link and no function -->
  <ng-container *ngIf="!item.link && !item.function && !item.disabled">
    <div
      [ngClass]="{
        'fuse-horizontal-navigation-item-active-forced': item.active
      }"
      class="fuse-horizontal-navigation-item"
      [matTooltip]="item.tooltip || ''">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
  </ng-container>

  <!-- Item is disabled -->
  <ng-container *ngIf="item.disabled">
    <div
      class="fuse-horizontal-navigation-item fuse-horizontal-navigation-item-disabled">
      <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>
  </ng-container>
</div>

<!-- Item template -->
<ng-template #itemTemplate>
  <!-- Icon -->
  <ng-container *ngIf="item.icon">
    <mat-icon
      [ngClass]="item.classes?.icon"
      class="fuse-horizontal-navigation-item-icon"
      [svgIcon]="item.icon"></mat-icon>
  </ng-container>

  <!-- Title & Subtitle -->
  <div class="fuse-horizontal-navigation-item-title-wrapper">
    <div class="fuse-horizontal-navigation-item-title">
      <span [ngClass]="item.classes?.title">
        {{ item.title }}
      </span>
    </div>
    <ng-container *ngIf="item.subtitle">
      <div class="fuse-horizontal-navigation-item-subtitle text-hint">
        <span [ngClass]="item.classes?.subtitle">
          {{ item.subtitle }}
        </span>
      </div>
    </ng-container>
  </div>

  <!-- Badge -->
  <ng-container *ngIf="item.badge">
    <div class="fuse-horizontal-navigation-item-badge">
      <div
        [ngClass]="item.badge.classes"
        class="fuse-horizontal-navigation-item-badge-content">
        {{ item.badge.title }}
      </div>
    </div>
  </ng-container>
</ng-template>
